import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useEditableContent } from "../../Context/EditableContentContext";
import { setTitle } from "../../redux/titleSlice";
import { useDispatch, useSelector } from "react-redux";
// import "./ProductHeader.css"; // Import your CSS file for styling

// ContactHeader component for displaying a header with navigation and buttons
const ProductHeader = ({ toggleSidebar }) => {
  const { editableProductContent, handleProductContentChange } =
    useEditableContent();
  const [isEditing, setIsEditing] = useState(false);
  const [newContent, setNewContent] = useState(editableProductContent);
  const title = useSelector((state) => state.title.title);
  const dispatch = useDispatch();

  const handleTitleClick = (e) => {
    e.preventDefault();
    setIsEditing(true);
  };

  const handleTitleChange = (e) => {
    dispatch(setTitle(e.target.value));
  };

  const handleInputChange = (e) => {
    setNewContent(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleProductContentChange(newContent);
      setIsEditing(false);
    }
  };

  const handleClick = () => {
    setIsEditing(true);
    handleProductContentChange(newContent);
  };

  const handleBlur = () => {
    handleProductContentChange(title);
    setIsEditing(false);
  };

  useEffect(() => {
    dispatch(setTitle("Product"));
  }, []);

  return (
    <nav className="navbar navbar-expand nav_mobile flex-column flex-md-row bottom-header-main  px-lg-5 px-2 py-2">
      <div className=" d-flex align-items-center d-md-flex ms-md-2">
        <div className="d-flex align-items-center bottom-header">
          {/* ====== Hamburger Button to Toggle The side Bar =========== */}
          <button
            className="sidebar-toggler flex-shrink-0 bg-transparent border-0 me-3"
            onClick={toggleSidebar}
          >
            <i className="fa fa-bars" />
          </button>

          <Link to="/templates" onClick={(e) => e.preventDefault()}>
            <div className="title-container" onClick={handleTitleClick}>
              {/* Title */}
              {/* {isEditing ? (
                <input
                  type="text"
                  value={title}
                  onChange={handleTitleChange}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                  autoFocus
                  className="editable-title"
                />
              ) : ( */}
                <h5 className="untitled-product-title">
                  {title ? title : "Product"}
                </h5>
              {/* )} */}
            </div>
            {/* Folder icon and preview text */}
            <p className="d-flex align-items-center">
              <i className="far fa-folder"></i>
              <span className="preview-text">Templates</span>
            </p>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default ProductHeader;
